var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import cookie from '../cookie/cookie';
import leftMenu from './console-common/left-menu.vue';
import topMenu from '../components/console-common/top-menu.vue';
import commonBread from '../components/console-common/common-bread.vue';
import msgWindow from '../components/console-common/console-msg-window.vue';
import announcementWindow from '../components/console-common/announcement-window.vue';
import agreementMode from '../views/fund/agreement.vue';
import agreementDataCredit from './console-common/agreement-data-credit.vue';
import warterMark from '../utils/water-mark-config';
export default Vue.extend({
    name: 'layout',
    components: {
        'el-left-menu': leftMenu,
        'el-top-menu': topMenu,
        'el-common-bread': commonBread,
        'el-msg-window': msgWindow,
        'el-announcement-window': announcementWindow,
        'el-agreement': agreementMode,
        'el-data-credit-agreement': agreementDataCredit,
    },
    computed: __assign({}, mapState('common', {
        agreementList: 'agreementList',
        popInstanceList: 'popInstanceList',
        popClearTimeout: 'popClearTimeout',
        dataCreditAgreementList: 'dataCreditAgreementList',
        popData: 'popData',
    }), mapState('user', {
        leftMenuList: 'leftMenuList',
    })),
    data: function () {
        return {
            loading: false,
            cityList: [],
            agreementVisible: false,
            dataCreditAgreementVisible: false,
            agreementListUnOpe: [],
            currentAgreement: {},
            currentDataCreditAgreement: {
                name: '',
                currentData: {},
            },
            dataCreditAgreementUnOpe: [],
        };
    },
    watch: {
        name: function (userId) {
            userId && warterMark(userId);
        },
        agreementList: function (val) {
            if (val.length === 0) {
                this.agreementVisible = false;
                return;
            }
            this.currentAgreement = val[0];
            this.agreementListUnOpe = val.slice(1);
            this.agreementVisible = true;
        },
        leftMenuList: function (val) {
            if (this.$route.path === '/console' && val && val.length > 0) {
                var defaultMenu = val[0];
                this.$router.push({
                    path: defaultMenu.children.length > 0
                        ? defaultMenu.children[0].url
                        : defaultMenu.url,
                });
            }
        },
        dataCreditAgreementList: function (val) {
            if (val.length === 0) {
                this.dataCreditAgreementVisible = false;
                return;
            }
            this.currentDataCreditAgreement = {
                name: val[0] ? val[0].capitalName : '',
                currentData: val[0],
            };
            this.dataCreditAgreementUnOpe = val.slice(1);
            this.dataCreditAgreementVisible = true;
        },
    },
    created: function () {
        this.getUserName();
        this.$store.dispatch('user/GET_MENU_LIST', { this_: this });
        this.getNotify();
        // 获取待签署协议
        this.$store.dispatch('common/GET_UNSIGNLIST');
    },
    beforeDestroy: function () {
        this.$store.commit('common/update', {
            popClearTimeout: false,
        });
        this.popInstanceList.forEach(function (item) {
            item.close();
        });
        this.$store.commit('common/update', {
            popInstanceList: [],
        });
    },
    methods: {
        getUserName: function () {
            this.name = cookie.getCookie('usernameZh');
            this.getCityList();
            this.getBusinessMsg();
        },
        getNotify: function () {
            this.$store.commit('common/update', {
                popClearTimeout: true,
            });
            this.$store.dispatch('common/GET_POPDATA', { callback: this.showNotify });
        },
        showNotify: function () {
            var _this = this;
            if (!this.popClearTimeout) {
                return;
            }
            if (!this.popData) {
                return setTimeout(function () {
                    _this.$store.dispatch('common/GET_POPDATA', {
                        callback: _this.showNotify,
                    });
                }, 300000);
            }
            var _a = this.popData, title = _a.title, content = _a.content;
            var popInstance = this.$notify({
                title: title,
                message: content,
                offset: 43,
                duration: 5000,
            });
            this.popInstanceList.push(popInstance);
            this.$store.commit('common/update', {
                popInstanceList: this.popInstanceList,
                popData: null,
            });
            this.$store.dispatch('common/UPDATESTATUS');
            this.showNotify();
        },
        getCityList: function () {
            var _this = this;
            this.$request({
                method: 'get',
                url: '/proxy/origin',
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (!res.errorCode) {
                    var arr = [];
                    for (var _i = 0, _a = res.data; _i < _a.length; _i++) {
                        var temp = _a[_i];
                        for (var _b = 0, _c = temp.cityDOList; _b < _c.length; _b++) {
                            var item = _c[_b];
                            arr.push(item);
                        }
                    }
                    _this.cityList = arr;
                    for (var _d = 0, _e = _this.cityList; _d < _e.length; _d++) {
                        var temp = _e[_d];
                        temp.type = false;
                        temp.key = temp.cityId;
                        temp.val = temp.cityId;
                        temp.label = temp.cityName;
                        temp.cityCode = temp.cityId;
                    }
                    var cityList = _this.cityList;
                    _this.$store.commit('info/update', {
                        cityList: cityList,
                    });
                }
            });
        },
        // 获取当前商户信息
        getBusinessMsg: function () {
            // 获取商户信息
            this.$store.dispatch('info/GET_BUSINESSMSG');
        },
        getNextAgreement: function () {
            if (this.agreementListUnOpe.length > 0) {
                this.currentAgreement = this.agreementListUnOpe[0];
                this.agreementListUnOpe = this.agreementListUnOpe.slice(1);
                this.agreementVisible = true;
            }
        },
        getNextCreditAgreement: function () {
            var _this = this;
            this.loading = true;
            if (this.dataCreditAgreementUnOpe.length > 0) {
                this.currentDataCreditAgreement = {
                    name: this.dataCreditAgreementUnOpe[0]
                        ? this.dataCreditAgreementUnOpe[0].capitalName
                        : '',
                    currentData: this.dataCreditAgreementUnOpe[0],
                };
                this.dataCreditAgreementUnOpe = this.dataCreditAgreementUnOpe.slice(1);
                this.dataCreditAgreementVisible = true;
                setTimeout(function () {
                    _this.loading = false;
                }, 1000);
                return;
            }
            this.dataCreditAgreementVisible = false;
            this.loading = false;
        },
    },
});
